import { useState } from "react";
import {
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import visaIon from '../../../assets/visa.svg'
 import masterIcon from '../../../assets/masterCard.svg'
import americanExpressIcon from '../../../assets/american-express.png'
import jcbIcon from '../../../assets/jcb.png'
import discoverIcon from '../../../assets/4373195_card_credit_discover_logo_logos_icon.png'
import unknownIcon from '../../../assets/unknown-card.png'
import { message } from "../../messages/Message";
import Loader from "../../Loader/Loader"
import { subscribePlan } from "../../services/operations/profileAPI";



const CardDetail = ({price}) => {

    const [loading, setLoading] = useState(false);
  const [cardBrand, setCardBrand] = useState('unknown');
  const dispatch = useDispatch();
  const loadings=useSelector((state)=>state.auth.loading)
  const token=useSelector((state)=>state.auth.token)
  const user=useSelector((state)=>state.profile.user)
  const stripe = useStripe();
  const elements = useElements();


  const handleCardChange = (event) => {
    if (event.brand) {

      setCardBrand(event.brand);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    if (!stripe || !elements) {
      setLoading(false)
      return;
    }

    const cardNumberElement = elements.getElement(CardNumberElement);
    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: cardNumberElement,
    });
    if (error) {
      toast.error(error.message);
      setLoading(false);
      return;
    }

    try {
      const payload = {
        payment_method: paymentMethod?.id,
        price_per_user: price.price_per_user,
      }

      const paymentIntentResponse = await dispatch(subscribePlan(token,payload))

      console.log("ree",paymentIntentResponse)
      if (paymentIntentResponse?.data?.status === 201) {
        toast.success(paymentIntentResponse.data.message);

      }
      else{
        toast.error("Some error occurred during payment,please try after some time")
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      toast.error(message.PaymnetFailureMessage);
    }
  };

  const getCardBrandIcon = (brand) => {
    switch (brand) {
      case "visa":
        return <img src={visaIon}  style={{top:"10px"}}alt="Visa" className="card-brand-icon" />;
      case "mastercard":
        return <img src={masterIcon} style={{top:"10px"}} alt="masterCard" className="card-brand-icon" />;
      case "amex":
        return <img src={americanExpressIcon} width={40} height={40} alt="americanExpress" className="card-brand-icon" />;
      case "discover":
        return <img src={discoverIcon} style={{ top: "0px" }} width={40} height={40} alt="discover" className="card-brand-icon" />;
      case "jcb":
        return <img src={jcbIcon}  width={40} height={40} alt="jcb" className="card-brand-icon" />;
      default:
        return <img src={unknownIcon}  width={40} height={40} alt="unknown" className="card-brand-icon" />;
    }
  };


  if (user?.is_premium) {
  return (
   <>
   </>
  );
}

  return (
    <form onSubmit={handleSubmit} className="card-container">
        {loadings && <Loader/>}
        <p className="billing-heading">Billing details</p>
      <p className="billing-amount-first-type">
        <span>Subtotal (with taxes)</span>
        <span>${price.intro_price}</span>
      </p>
      <p className="billing-amount-first-type total">
        <span>TOTAL AMOUNT</span>
        <span>${price.intro_price}</span>
      </p>
      <div className="payment-form-group">
        <label>Card Number</label>
        <div className="card-number-container">
          <CardNumberElement
            options={{
              placeholder: "XXXX XXXX XXXX XXXX",
              autocomplete: "off", 
              disableLink: true, 
              style: {
                base: {
                  color: "rgba(0, 0, 0, 0.6)",
                   fontFamily: "'Nunito Sans', sans-serif", 
                  fontSize: "20px",
                  iconColor: "rgba(0, 0, 0, 0.6)",
                  fontWeight:"700",
                  letterSpacing:"20px",
                  "::placeholder": {
                    color: "rgba(0, 0, 0, 0.6)",
                  },
                },
              },
            }}
            className="payment-card-number-input"
            onChange={handleCardChange}
          />
          <span className="card-brand-icon-container">
            {cardBrand && getCardBrandIcon(cardBrand)}
          </span>
        </div>
      </div>
<div className="payment-expiry-cvv">
     <div className="payment-form-group">
        <label>Expiry Date</label>
        <CardExpiryElement
          options={{
            style: {
              base: {
                color: "rgba(0, 0, 0, 0.6)",
                fontFamily: "'Nunito Sans', sans-serif", 
                fontSize: "20px",
                textAlign:"center",
                fontWeight:"700",
                "::placeholder": {
                  color: "rgba(0, 0, 0, 0.6)",
                },
              },
            },
          }}
          className="payment-card-input"
        />
      </div>
      <div className="payment-form-group">
        <label>CVV</label>
        <CardCvcElement
          options={{
             placeholder: "XXX",
            style: {
              base: {
                color:"rgba(0, 0, 0, 0.6)",
               fontFamily: "'Nunito Sans', sans-serif", 
                fontSize: "20px",
                letterSpacing:"8px",
                textAlign:"center",
                fontWeight:"700",
                "::placeholder": {
                  color: "rgba(0, 0, 0, 0.6)",
                },
              },
            }
          }}
          className="payment-card-input"
        />
      </div>
</div>
     

      {/* Submit Button */}
      {
        !user?.is_premium ? ( <p className="billing-link">
          <a href="/business-dashboard/help-desk">I need help with billing issues</a>
          <button
        type="submit"
        className="billing-button"
        disabled={!stripe || loading}
      >
        {loading ? "Payment Processing..." : "Continue with Payment"}
      </button>
        </p>):(
           <p className="billing-link">
          <a href="/business-dashboard/help-desk">I need help with billing issues</a>
          <button
        type="submit"
        className="billing-button"
      >
      Update My Card
      </button>
        </p>
        )
      }
    </form>
  );
};

export default CardDetail;